import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import myCustomersApi from '../../api/MyCustomersApi';
import { formatNumber } from 'src/utils/helperFunctions';

const ShowOrderCell: FC<GridCellProps> = ({ dataItem, colSpan, columnIndex, isSelected, ariaColumnIndex, className, style, field, format }) => {
  const createLogin = (customer: string, showId: number) => {
    myCustomersApi.createLogin(customer).then((res) => {
      let a = document.createElement('a');
      a.target = '_blank';
      a.href = `${res.showUrl}?showId=${showId}`;
      a.click();
    });
  };

  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected={isSelected}
      data-grid-col-index={columnIndex}
      style={{ ...style, textAlign: 'right' }}
    >
      <a className="text-link" onClick={() => createLogin(dataItem.customerNumber.toString(), dataItem.showId)}>
        {formatNumber(dataItem[field], format)}
      </a>
    </td>
  );
};

export default ShowOrderCell;
